import { z } from "zod"

export const VersionConfigSchema = z.object({
    min_supported_version: z.string().regex(/^\d+\.\d+(?:\.\d+)?$/),
    min_supported_build_number: z.number(),
    latest_version: z.string().regex(/^\d+\.\d+(?:\.\d+)?$/),
    latest_build_number: z.number(),
    maintenance_mode: z.boolean(),
    upgrade_message: z.string(),
})

export type VersionConfig = z.infer<typeof VersionConfigSchema>

export const VersionConfigsSchema = z.object({
    android: VersionConfigSchema,
    ios: VersionConfigSchema,
})

export const FeatureFlagsSchema = z.record(z.string(), z.object({ enabled: z.boolean() }))
export type FeatureFlags = z.infer<typeof FeatureFlagsSchema>

export const MobilePlatformSchema = z.union([z.literal("ios"), z.literal("android")])
export type MobilePlatform = z.infer<typeof MobilePlatformSchema>
